import React, { useState } from 'react';
import { INSTAGRAM_FEED } from '../content-types';
import { trackContainerClick } from '../analytics';
import { useTranslator } from 'tradera/lang/translate';
import InstagramIcon from '@tradera/blueprint/theme/icons/instagram.svg?jsx';
import ImageIcon from '@tradera/blueprint/theme/icons2/image.svg?jsx';
import { StartPageSection } from '../start-page-section/start-page-section';
import { StartPageSectionTitle } from '../start-page-section/start-page-section-title';
import {
    getInstagramQueryParams,
    useGetInstagramFeedQuery
} from 'tradera/state/services/discover-api';

const InstagramFeed = () => {
    const { t } = useTranslator();
    const { data } = useGetInstagramFeedQuery(getInstagramQueryParams());
    const posts = data?.posts || [];

    if (posts.length === 0) {
        return null;
    }

    return (
        <StartPageSection className="instagram-feed">
            <StartPageSectionTitle>
                {t('instagramFeed_header')}
            </StartPageSectionTitle>
            <div className="d-flex flex-wrap flex-lg-nowrap ml-2 ml-md-3 mr-md-1 ml-lg-2 ml-xl-1 mr-lg-0 mr-xl-n1">
                {posts &&
                    posts
                        .slice(0, 8)
                        .map((post, index) => (
                            <InstagramImage
                                imageUrl={post.imageUrl}
                                url={post.url}
                                key={index}
                            />
                        ))}
            </div>
        </StartPageSection>
    );
};

const InstagramImage = ({ imageUrl, url }) => {
    const [imageAvailable, setImageAvailable] = useState(true);

    return (
        <div className="instagram-feed__post pr-2 pb-2">
            <a
                aria-label="Instagram post"
                className="instagram-feed__image d-block"
                href={url}
                target="_blank"
                onClick={() =>
                    trackContainerClick(INSTAGRAM_FEED, 'Instagram post')
                }
                rel="nofollow noopener noreferrer">
                {imageAvailable ? (
                    <img
                        src={imageUrl}
                        alt="Instagram post"
                        loading="lazy"
                        onError={() => setImageAvailable(false)}
                    />
                ) : (
                    <span className="d-block fallback-image">
                        <div className="w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200">
                            <ImageIcon
                                style={{ width: '8rem', height: '8rem' }}
                                className="icon icon-gray-300"
                            />
                        </div>
                    </span>
                )}
                <InstagramIcon className="instagram-feed__icon icon icon-md icon-white position-absolute" />
            </a>
        </div>
    );
};

export default InstagramFeed;
